import createLucideIcon from '../createLucideIcon';

const Loader2 = createLucideIcon('Loader2Icon', [
  ['path', { d: 'M21 12a9 9 0 1 1-6.219-8.56', key: '13zald' }],
]);

export default Loader2;
